import React, { useRef, useEffect } from 'react';
import { useCodeMirror } from '@uiw/react-codemirror';
import {javascript} from "@codemirror/lang-javascript";
import useLocalStorage from '../hooks/useLocalStorage';

export default function GroupEditor({ value, onChange, editorKey }) {
    const editorContainer = useRef(null);
    const [code, setCode] = useLocalStorage(editorKey, value);

    const { view } = useCodeMirror({
        container: editorContainer.current,
        value: code,
        extensions: [javascript()],
        onChange: (newCode) => {
            setCode(newCode);
            onChange(newCode);
        },
        height: "270px",
    });

    useEffect(() => {
        return () => {
            if (view) {
                view.destroy();
            }
        };
    }, [view]);

    return <div ref={editorContainer} className="code-mirror-wrapper" />;
}